import { render } from "./ModalWidget.vue?vue&type=template&id=7fd9c62e"
import script from "./ModalWidget.vue?vue&type=script&lang=js"
export * from "./ModalWidget.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ferha\\workspace\\calculus\\digyinfo-demo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__